import { Extension } from "@tiptap/core";
import Suggestion from "@tiptap/suggestion";

import { createChipSuggestion } from "./chip-suggestion";
import { SlashCommandList } from "./slash-command-list";
import { filterSlashItems, type SlashItem } from "./slash-items";

/**
 * Linear-style `/` block menu.
 *
 * Trigger only at the start of a block so typing `https://` or `w/demo`
 * does not open it. Selecting an item deletes the `/query` and applies
 * the block command; the document still serializes as markdown.
 */
export const SlashCommand = Extension.create({
  name: "slashCommand",
  addKeyboardShortcuts() {
    return {
      "Mod-Shift-9": () => this.editor.commands.toggleOrderedList(),
      "Mod-Shift-7": () => this.editor.commands.toggleTaskList(),
      "Mod-Shift-\\": () => this.editor.commands.toggleCodeBlock(),
    };
  },
  addProseMirrorPlugins() {
    return [
      Suggestion<SlashItem>({
        editor: this.editor,
        startOfLine: true,
        ...createChipSuggestion({
          char: "/",
          items: (query) => filterSlashItems(query),
          component: SlashCommandList,
          componentProps: (props) => ({
            items: props.items,
            command: (item: SlashItem) => props.command(item),
          }),
        }),
        command: ({ editor, range, props }) => {
          editor.chain().focus().deleteRange(range).run();
          props.apply(editor);
        },
      }),
    ];
  },
});
